import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import {
  CreateStoreInput,
  Store,
  StoreListParams,
  StoreListResponse,
  UpdateStoreInput,
} from 'models/Store';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

const BASE = '/portal-go/stores';

export const StoreService = {
  list: async (
    params: StoreListParams = {}
  ): Promise<ApiResponse<StoreListResponse | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`${BASE}/list`, {
        params: {
          term: params.term || undefined,
          filter: params.filter || 'ALL',
          page: params.page || 1,
          pageSize: params.pageSize || 10,
        },
      });

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  findById: async (id: number): Promise<ApiResponse<Store | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`${BASE}/find-by-id/${id}`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  create: async (
    body: CreateStoreInput
  ): Promise<ApiResponse<Store | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(`${BASE}/create`, body);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  update: async (
    id: number,
    body: UpdateStoreInput
  ): Promise<ApiResponse<Store | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(`${BASE}/update/${id}`, body);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  setVip: async (
    id: number,
    isVip: boolean
  ): Promise<ApiResponse<Store | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(`${BASE}/set-vip/${id}`, {
        isVip,
      });

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  setActive: async (
    id: number,
    isActive: boolean
  ): Promise<ApiResponse<Store | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(`${BASE}/set-active/${id}`, {
        isActive,
      });

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },

  delete: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.delete(`${BASE}/delete/${id}`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
